import { v4 as uuidv4 } from 'uuid';

export const CHAT_API_URL = 'https://chat.kodif.io/api/v1';
export const ML_SERVICE_API_URL = 'https://ml-service.kodif.io/api/v1';

export const BASE_URL = process.env.REACT_APP_CHAT_URL || 'https://chat.kodif.io';
export const AUTOPILOT_URL = process.env.REACT_APP_AUTOPILOT_URL || 'https://gateway.kodif.io/autopilot';
export const AWS_WEB_SOCKET_URL = process.env.AWS_WEBSOCKET_URL || 'wss://vf2buvq508.execute-api.us-west-1.amazonaws.com/production';
export const HARDCODED_USER = {
  id: uuidv4(),
  name: 'You',
  type: 'user',
};

export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

export const rollbarConfig = {
  accessToken: 'c703c1d101ee4619b4508ac7c6c31346',
  environment: IS_DEVELOPMENT ? 'development' : 'production',
  enabled: !IS_DEVELOPMENT,
};

export const CONTAINER_WIDTH = 400;
export const CONTAINER_HEIGHT = 700;
